<template>
  <div class="wrapper">
    <portal-target name="layout-main" class="layout-main panel-scroll-full">
      <div class="panel-detail panel-fixed panel-with-actions">
        <div class="panel-header">
          <h1 class="page-header d-flex align-items-center">
            {{ $t('Task') }}<span v-if="detail && detail.id"> #{{ detail.id }}</span>
          </h1>
          <ol class="breadcrumb pull-right">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'dashboard' }">{{ 'Dashboard' }}</router-link>
            </li>
            <li class="breadcrumb-item" v-if="organizationRoute">
              <router-link :to="organizationRoute">{{ detail.organization_name || $t('Organization') }}</router-link>
            </li>
            <li class="breadcrumb-item">{{ 'Task' | translate }}</li>
          </ol>
        </div>
        <task-edit :id="detailId" @close-form="goBack" />
      </div>
    </portal-target>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TaskEdit from './TaskEdit.vue'
import { TYPES as TASK_TYPES } from './store'
import { ROUTES as OWNER_ORG_ROUTES } from '@/pages/organization/organization/organization/owner-organization/router'

export default {
  name: 'TaskDetailPage',
  props: { id: { required: true } },
  components: { 'task-edit': TaskEdit },
  computed: {
    ...mapGetters({
      detail: TASK_TYPES.GENERIC.task.task.DETAIL.GETTERS.detail
    }),
    detailId () {
      return this.id
    },
    organizationRoute () {
      if (this.detail && this.detail.organization) {
        return {
          name: OWNER_ORG_ROUTES.OWNER_ORGANIZATION_DETAIL,
          params: { id: this.detail.organization }
        }
      }
      return null
    }
  },
  methods: {
    goBack () {
      if (this.detail && this.detail.organization) {
        this.$router.push({
          name: OWNER_ORG_ROUTES.OWNER_ORGANIZATION_TASK,
          params: { id: this.detail.organization }
        })
      } else {
        this.$router.back()
      }
    }
  }
}
</script>
